import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-1 text-xs text-foreground-500">
      <Link to="/" className="hover:text-primary-600 cursor-pointer">
        首页
      </Link>
      {items.map((c) => (
        <span key={c.label} className="flex items-center gap-1">
          <i className="ri-arrow-right-s-line text-foreground-400" />
          {c.path ? (
            <Link to={c.path} className="hover:text-primary-600 cursor-pointer">
              {c.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}